export const warmups = [
  // {
  //   name: "正在產生影片中，請稍候。在影片完成之前，歡迎點擊精選問題，了解您有興趣的題目，謝謝",
  //   filename: "h.webm",
  // },
  // {
  //   name: "正在產生影片中請稍候，在此之前，先向您介紹遠傳與微軟的現況，遠傳與微軟自2018年一直是微軟重要的戰略合作夥伴，並於今年深化戰略結盟，相信微軟透過結合遠傳在電信及數位服務的專業經驗，以及遠東集團的創新能量，必定能賦能台灣產業及中小企業，共同打造更智慧永續的未來，共同加速台灣數位成長",
  //   filename: "i.webm",
  // },
  {
    name: "您的問題請給我一點時間思考一下，謝謝",
    filename: "k.mp4",
  },
];
